<template>
  <div>
    <base-table-header
      outlined-button
      :options="{ header: 'py-2' }"
      :search-input="false"
      :btn-add="false"
      :btn-download="false"
      :btn-reload="false"
    >
      <template v-slot:subtitle>
        <div class="body-1 black--text">
          Jumlah Peserta <span class="blue--text font-weight-medium">{{ pesertas.length }}</span>
        </div>
      </template>
      <template v-slot:toolbarAfter>
        <v-btn
          v-if="$allow('psp-pelatihan-imbas-kelas.save-sekolah')"
          color="primary"
          class="ml-2"
          depressed
          @click="onEdit"
        >
          <v-icon left dark class="mr-1">
            {{ sekolahs.length ? 'mdi-pencil' : 'mdi-plus' }}
          </v-icon>
          {{ sekolahs.length ? 'Ubah' : 'Tambah' }}
        </v-btn>
      </template>
    </base-table-header>
    <v-divider />
    <base-list-table
      :hideHeader="true"
      :loading="false"
      :item="sekolahs"
      :total="sekolahs.length"
      :usePaging="false"
      :emptyMsg="`Anda tidak memiliki data peserta kelas pelatihan pengimbasan`"
    >
      <template slot-scope="{ item }">
        <td>
          <v-list>
            <v-list-item class="px-0">
              <v-list-item-avatar color="blue">
                <v-icon dark>mdi-home</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <v-label color="caption">
                      <small>Sekolah</small>
                    </v-label>
                    <div class="text-body-1 font-weight-medium">{{ $getDeepObj(item, 'sekolah.nama') }}</div>
                    <div class="text-body-2">
                      NPSN: <span class="font-weight-medium">{{ $getDeepObj(item, 'sekolah.npsn') }}</span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" v-for="(peserta, id) in $getDeepObj(item, 'peserta') || []" :key="id">
                    <v-label color="caption">
                      <small>Peserta {{ Number(id) + 1 }}</small>
                    </v-label>
                    <div class="text-body-1 font-weight-medium">{{ $getDeepObj(peserta, 'ptk.nama') }}</div>
                    <div class="text-body-2">
                      SIMPKB ID: <span class="font-weight-medium">{{ $getDeepObj(peserta, 'ptk_id') }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </td>
      </template>
    </base-list-table>
    <base-modal-full ref="modal" :title="formulir.title" @save="onSave">
      <form-peserta ref="formulir" :initValue="formulir.init" :masters="masters" :min="min" :max="max" />
    </base-modal-full>
  </div>
</template>

<script>
import BaseTableHeader from '@components/base/BaseTableHeader.vue';
import BaseListTable from '@components/base/BaseListTable.vue';
import FormPeserta from '@views/instansi/pengimbasan/kelas/form/Peserta.vue';
import { mapActions } from 'vuex';

export default {
  name: 'PesertaDetail',
  components: { FormPeserta, BaseListTable, BaseTableHeader },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      min: 10,
      max: 20,
      formulir: {},
    };
  },
  computed: {
    pesertas() {
      return (this.$getDeepObj(this.detail, 'psp_pelatihan_kelas_pesertas') || []).filter(
        (item) => +item.k_pelatihan_peserta_psp === 1
      );
    },
    sekolahs() {
      return (this.$getDeepObj(this.detail, 'psp_pelatihan_kelas_sekolahs') || []).map((sekolah) => {
        return Object.assign(sekolah, {
          peserta: this.pesertas.filter((peserta) => +peserta.sekolah_id === +sekolah.sekolah_id),
        });
      });
    },
  },
  methods: {
    ...mapActions('pengimbasanKelas', ['action']),

    onEdit() {
      this.$set(this.formulir, 'title', this.sekolahs.length ? 'Tambah Peserta Kelas' : 'Ubah Peserta Kelas');
      this.$set(this.formulir, 'init', null);
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', this.sekolahs);
      });
    },

    onSave() {
      const values = this.$refs.formulir.getValue();

      if (values.length > this.max) {
        this.$error(`Anda hanya boleh memilik maksimal ${this.max} sekolah`);
        this.$refs.modal.loading = false;
        return;
      }

      this.action({ endpoint: 'save-sekolah', id: this.detail.psp_pelatihan_kelas_id, params: { sekolah: values } })
        .then(() => {
          this.$success('Data peserta berhasil disimpan');
          this.$refs.modal.close();
          this.$emit('reload');
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
